import PubSub from 'pubsub-js';
import {
  MEASURE_UNIT_NAME,
  // GENERATE_MAP_TYPE,
  // REVERSE_PROPERTY_MAP,
  TEXTURE_MAP,
  TEXTURE_MAP_TO_TILING_TYPE,
  TEXTURE_MAP__TEXTURE_NAME_KEY,
  // TILING_MAP,
  TILING_NAME_MAP,
  TILING_TEXTURE_MAP,
  TILING_TYPE,
} from '../../../../config/constant/unityConstants';
import { convertActiveUnitToCM, toggleExpertMode } from '../../../../helpers/curatorActions';
import {
  // getMaterial,
  getTexture,
} from '../../../../helpers/idb';
import { wait } from '../../../../helpers/jsHelper';
import { dispatcher } from '../../../../helpers/projectHelper';
import {
  combineUnityObjectDataWithReact,
  // inchesToUnitySize,
} from '../../../../helpers/unityHelper';
import { AppEvent, UnityEvent, waitForEventOnce } from '../../../../helpers/unityPubSub';
import {
  setGenerateFromDesignLoading,
  // setPasteMaterialLoading,
  setUndoRedoLoading,
} from '../../../../redux/slicers/admin/curatorLoaderSlicer';
import {
  selectActiveMeasureUnitsName,
  setCuratorLoader,
} from '../../../../redux/slicers/admin/curatorSlicer';
import {
  selectCopiedObjectProperties,
  selectDataByTilingType,
  selectParsedObject,
  selectSelectedObjectList,
  selectSelectedObjectName,
  selectUnitySelectedObjectInfoRaw,
  updateUnityObject,
} from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import { updateUndoRedoColorCounter } from '../../../../redux/slicers/admin/undoRedoSlicer';
import { getAppState } from '../../../../redux/store';
import { getDefaultTextureImageUrl } from '../stylesSection/PropertiesTab/useGetDefaultObjectMaps';
// import { initialTextures } from '../stylesSection/useUnityRedux';
import { ACTION } from './undoRedoConstants';
import { mapObjectToSelect } from './UndoRedoUnityObject';
import { applyOption, validateUndoRedo } from '../../../Configurator/unity/objectPropertiesMethods';
import { isMattressBuilderPage, selectUnityObject } from '../ProductBuilderComponents/commonHelper';
import { undoRedo } from './UndoRedo';
import { successToast, warningToast } from '../../../../helpers/toastHelper';

export class UndoRedoObjectProperties {
  constructor({
    undoRedoInstance,
    unityObjectProperties,
    unityColor,
    unityContext,
    unityMaterial,
  }) {
    this.undoRedo = undoRedoInstance;
    this.unityObjectProperties = unityObjectProperties;
    this.unityColor = unityColor;
    this.unityContext = unityContext;
    this.unityMaterial = unityMaterial;
    this.skipChangeTilingPropertiesEventOnce = false;
    this.textureMaterialApplyHistory = {
      // example: ['texture', 'material', 'texture', 'color', 'color']
    };
    this.copyPasteData = {
      materialList: [],
      objectsBeforePaste: [],
      pasteParams: null,
      materialConfig: null,
    };
    this.subscribeTokens = [];
    this.init();
    this.subscribe();
  }

  subscribe = () => {
    const token = PubSub.subscribe(UnityEvent.PasteMaterialPropertiesFinishedReceive, () => {
      this.copyPasteMaterialFinished();
    });
    const token1 = PubSub.subscribe(
      UnityEvent.ReceiveObjectInfoBeforePasteMaterial,
      (_, objectData) => {
        this.copyPasteData.objectsBeforePaste.push(objectData);
      }
    );
    const token2 = PubSub.subscribe(
      UnityEvent.OnReceiveUpdatedPasteMaterialData,
      (_, materialConfig) => {
        this.copyPasteData.materialConfig = materialConfig;
      }
    );
    this.subscribeTokens.push(token);
    this.subscribeTokens.push(token1);
    this.subscribeTokens.push(token2);
  };

  unsubscribe = () => {
    this.subscribeTokens.forEach((token) => PubSub.unsubscribe(token));
    this.subscribeTokens = [];
  };

  addCopyPasteData = ({ materialId, objectName }) => {
    // when user paste material we will get target/targets material data which we store to make it possible to undo later
    this.copyPasteData.materialList.push({
      materialId,
      objectName,
    });
  };

  addPasteMaterialParams = (textureListOrNothing) => {
    this.copyPasteData.pasteParams = textureListOrNothing;
  };

  resetCopyPasteData = () => {
    this.copyPasteData = {
      materialList: [],
      objectsBeforePaste: [],
      pasteParams: null,
      materialConfig: null,
    };
  };

  _waitForObjectProperties = async () => {
    await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo, () => {
      this.unityContext.materialModule.OnSelectEditMaterialReceiver();
    });
  };

  _update = (tilingOptionType, data) => {
    dispatcher(
      updateUnityObject({
        [TILING_NAME_MAP[tilingOptionType]]: data,
      })
    );
  };

  _getKey = (objectName, mapType) => {
    return `${objectName}__${mapType}`;
  };

  _getLastApplied = (objectName, mapType) => {
    const key = this._getKey(objectName, mapType);
    const item = this.textureMaterialApplyHistory[key];
    return item[item.length - 1];
  };

  _addApplyTextureToHistory = (objectName, mapType, type) => {
    const key = this._getKey(objectName, mapType);
    if (!this.textureMaterialApplyHistory[key]) {
      this.textureMaterialApplyHistory[key] = [];
    }
    this.textureMaterialApplyHistory[key].push(type);
  };

  _removeLastApplied = (objectName, mapType) => {
    const key = this._getKey(objectName, mapType);
    const item = this.textureMaterialApplyHistory[key];
    item.pop();
  };

  _resetTilingValues = (tiling) => {
    this.unityContext.materialModule.OnUpdateRotationReceiver({
      ...tiling,
      tilingOptionType: tiling.tilingType,
    });
    this._update(tiling.tilingType, tiling);
  };

  _resetTilingAfterTextureApplied = (tiling) => {
    PubSub.subscribeOnce(AppEvent.ReceiveSelectedObjectInfoHandled, () => {
      this._resetTilingValues(tiling);
    });
  };

  _applyTiling = async (tiling) => {
    const texture = await getTexture(tiling.materialId);
    const mapType = TILING_TEXTURE_MAP[tiling.tilingType];
    this._skipChangeTilingPropertiesEventOnce = true;
    // wait for texture to be applied before reset tiling values
    this._resetTilingAfterTextureApplied(tiling);
    // apply texture
    await this.unityObjectProperties.applyTexture({
      mapType,
      texture,
      switchToProperties: true,
      skipHistory: true,
    });
  };

  _applyDefaultMaterialOrColor = async ({
    tilingType,
    objectName,
    mapType,
    materialId,
    color,
    rawObject,
    parsedObject,
  }) => {
    const textureMap = TILING_TEXTURE_MAP[tilingType];
    const textureNameKey = TEXTURE_MAP__TEXTURE_NAME_KEY[textureMap];
    const textureName = rawObject[textureNameKey];
    const textureUrl = await getDefaultTextureImageUrl({ textureName, materialId });
    if (textureUrl || tilingType !== TILING_TYPE.TEXTURE) {
      const updatedRawObject = combineUnityObjectDataWithReact(rawObject, parsedObject);
      updatedRawObject['methodName'] = '_applyDefaultMaterialOrColor';
      // Use the object-specific receiver so undo does not broadcast styles to other props.
      await this.unityContext.materialModule.SetMaterialPropertiesOnGivenObject(
        updatedRawObject,
        objectName
      );
      const object = { ...updatedRawObject, TRIGGERED_FROM_REACT: true };
      PubSub.publish(UnityEvent.ReceiveSelectedObjectInfo, JSON.stringify(object)); // simulate unity trigger to go through all flow of selecting styleable object
    } else {
      this.unityContext.materialModule.OnUpdateColorReceiver(color);
      await this._waitForObjectProperties();
    }
  };

  _undoMaterial = async (rawObject, parsedObject, { useObjectReceiver = false } = {}) => {
    await wait(10);
    const updatedRawObject = combineUnityObjectDataWithReact(rawObject, parsedObject);
    const objectName = rawObject?.objectName || updatedRawObject?.objectName;
    // updatedRawObject['methodName'] = '_undoMaterial'
    const object = { ...updatedRawObject, TRIGGERED_FROM_REACT: true };
    dispatcher(setCuratorLoader(false));
    await waitForEventOnce(UnityEvent.ApplyMaterialPropertiesFinishedReceive, async () => {
      if (useObjectReceiver) {
        // Copy-paste undo: object is already selected via SelectObjectReceiver, apply only to
        // the currently selected object to avoid bleeding styles onto the copy source.
        await this.unityContext.materialModule.SetMaterialPropertiesOnObjectReceiver(
          updatedRawObject
        );
      } else {
        // Regular undo: target the specific object by name so it does not broadcast styles
        // to other objects sharing the same material.
        await this.unityContext.materialModule.SetMaterialPropertiesOnGivenObject(
          updatedRawObject,
          objectName
        );
      }
    });
    await waitForEventOnce(AppEvent.ReceiveSelectedObjectInfoHandled, () => {
      PubSub.publish(UnityEvent.ReceiveSelectedObjectInfo, JSON.stringify(object)); // simulate unity trigger to go through all flow of selecting styleable object
    });
    dispatcher(setCuratorLoader(true));
  };

  _addApplyTextureToHistoryInConfigurator = ({ sceneId, labelId, optionId, type }) => {
    const key = this._getKeyInConfigurator({ sceneId, labelId, optionId });
    if (!this.textureMaterialApplyHistory[key]) {
      this.textureMaterialApplyHistory[key] = [];
    }
    this.textureMaterialApplyHistory[key].push(type);
  };

  _getKeyInConfigurator = ({ sceneId, labelId, optionId }) => {
    return `${sceneId}__${labelId}__${optionId}`;
  };

  _removeLastAppliedInConfigurator = ({ sceneId, labelId, optionId }) => {
    const key = this._getKeyInConfigurator({ sceneId, labelId, optionId });
    const item = this.textureMaterialApplyHistory[key];
    item.pop();
  };

  _undoMaterialTextureColorInConfigurator = async ({ option }) => {
    await wait(10);
    await applyOption({
      option,
      skipHistory: true,
    });
  };

  _undoColorMaterialTexture = async ({
    prevTiling,
    objectName,
    mapType,
    color,
    rawObject,
    parsedObject,
  }) => {
    // TODO: when we revert last material apply -> we need to check if there was a different material applied before that, if there was we need to apply it first and then apply previous texture, color
    this._removeLastApplied(objectName, mapType);
    const lastApplied = this._getLastApplied(objectName, mapType);
    if (lastApplied === 'color') {
      // this.unityContext.materialModule.OnUpdateColorReceiver(color);
      this.unityColor.changeColor(color);
      await this._waitForObjectProperties();
    } else if (lastApplied === 'texture') {
      await this._applyTiling(prevTiling);
      // const texture = await getTexture(prevTiling.materialId);
      // this._skipChangeTilingPropertiesEventOnce = true;

      // // wait for texture to be applied before reset tiling values
      // this._resetTilingAfterTextureApplied(prevTiling);

      // // apply texture
      // await this.unityObjectProperties.applyTexture({
      //   mapType,
      //   texture,
      //   switchToProperties: true,
      //   skipHistory: true,
      // });
    } else if (lastApplied === 'material') {
      await this._undoMaterial(rawObject, parsedObject);
    } else {
      if (prevTiling?.materialId) {
        // texture was applied to this project already (saved)
        await this._applyTiling(prevTiling);
      } else {
        await this._applyDefaultMaterialOrColor({
          tilingType: prevTiling.tilingType,
          mapType,
          objectName,
          color,
          materialId: rawObject.loadedMaterialId,
          rawObject,
          parsedObject,
        });
      }
    }
  };

  init = () => {
    this.toggleExpertMode = this.undoRedo.createAction(({ prevValue }) => {
      const nextValue = !prevValue;
      const objectName = selectSelectedObjectName(getAppState());
      return {
        undo: () => {
          toggleExpertMode({ enabled: prevValue, objectName });
        },
        redo: () => {
          toggleExpertMode({ enabled: nextValue, objectName });
        },
      };
    });

    this.updateObject = this.undoRedo.createAction(({ name, prevValue, nextValue, data }) => {
      const { tilingOptionType } = data;
      return {
        name,
        prevValue,
        nextValue,
        data,
        undo: () => {
          this.unityObjectProperties.modifyTiling(tilingOptionType, name, prevValue, {
            skipHistory: true,
          });
        },
        redo: () => {
          this.unityObjectProperties.modifyTiling(tilingOptionType, name, nextValue, {
            skipHistory: true,
          });
        },
      };
    });

    this.changeSize = this.undoRedo.createAction(({ prevValue, nextValue, data }) => {
      const { tilingOptionType } = data;
      console.log('DEBUGGER undoredo changeSize', prevValue, nextValue, data);
      let prevWidth = prevValue.width;
      let prevHeight = prevValue.height;
      let nextWidth = nextValue.width;
      let nextHeight = nextValue.height;
      const measureUnitName = selectActiveMeasureUnitsName(getAppState());
      if (!measureUnitName || measureUnitName !== MEASURE_UNIT_NAME.CM) {
        prevWidth = convertActiveUnitToCM(prevValue.width);
        prevHeight = convertActiveUnitToCM(prevValue.height);
        nextWidth = convertActiveUnitToCM(nextValue.width);
        nextHeight = convertActiveUnitToCM(nextValue.height);
      }
      return {
        prevValue,
        nextValue,
        data,
        undo: () => {
          this.unityObjectProperties.changeSize({
            tilingOptionType,
            width: prevWidth,
            height: prevHeight,
          });
        },
        redo: () => {
          this.unityObjectProperties.changeSize({
            tilingOptionType,
            width: nextWidth,
            height: nextHeight,
          });
        },
      };
    });

    this.changePosition = this.undoRedo.createAction(({ prevValue, nextValue, data }) => {
      const { tilingOptionType } = data;
      return {
        prevValue,
        nextValue,
        data,
        undo: () => {
          this.unityObjectProperties.changePosition({
            tilingOptionType,
            x: prevValue.x,
            y: prevValue.y,
          });
        },
        redo: () => {
          this.unityObjectProperties.changePosition({
            tilingOptionType,
            x: nextValue.x,
            y: nextValue.y,
          });
        },
      };
    });

    this.changeColor = this.undoRedo.createAction(
      ({ prevTiling, prevValue, nextValue, parsedObject, rawObject }) => {
        const objectName = selectSelectedObjectName(getAppState());
        this._addApplyTextureToHistory(objectName, TEXTURE_MAP.DIFFUSE, 'color');
        const _parsedObject = parsedObject || selectParsedObject(getAppState());
        const _rawObject = rawObject || selectUnitySelectedObjectInfoRaw(getAppState());
        return {
          prevValue,
          nextValue,
          undo: async () => {
            if (isMattressBuilderPage()) {
              undoRedo.pause();
              const itemsToSelect = {
                objectName: objectName,
                ObjectSelectionMode: 'Style',
                clickedObjectName: '',
              };
              window.unityContext?.mainController?.SelectObjectReceiver([itemsToSelect]);
              // await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo);
              undoRedo.resume();
            }
            await this._undoColorMaterialTexture({
              prevTiling,
              objectName,
              color: prevValue,
              mapType: TEXTURE_MAP.DIFFUSE,
              parsedObject: _parsedObject,
              rawObject: _rawObject,
            });
            await wait(20);
            dispatcher(updateUndoRedoColorCounter());
          },
          redo: async () => {
            if (isMattressBuilderPage()) {
              undoRedo.pause();
              const itemsToSelect = {
                objectName: objectName,
                ObjectSelectionMode: 'Style',
                clickedObjectName: '',
              };
              window.unityContext?.mainController?.SelectObjectReceiver([itemsToSelect]);
              // await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo);
              undoRedo.resume();
            }

            this._addApplyTextureToHistory(objectName, TEXTURE_MAP.DIFFUSE, 'color');
            this.unityColor.changeColor(nextValue);
          },
        };
      }
    );

    this.changeTilingProperties = this.undoRedo.createAction(({ prevValue, nextValue, data }) => {
      const { tilingOptionType } = data;
      // TODO: work on this logic -> skip it until texture is applied
      if (this._skipChangeTilingPropertiesEventOnce) {
        this._skipChangeTilingPropertiesEventOnce = false;
        return;
      }
      return {
        prevValue,
        nextValue,
        data,
        undo: () => {
          this.unityContext.materialModule.OnUpdateRotationReceiver({
            ...prevValue,
            tilingOptionType,
          });
          this._update(tilingOptionType, prevValue);
        },
        redo: () => {
          this.unityContext.materialModule.OnUpdateRotationReceiver({
            ...nextValue,
            tilingOptionType,
          });
          this._update(tilingOptionType, nextValue);
        },
      };
    });

    // apply texture/custom map
    this.applyTexture = this.undoRedo.createAction(
      ({ prevTiling, nextTexture, mapType, parsedObject, rawObject }) => {
        if (parseInt(prevTiling?.materialId) === parseInt(nextTexture.id)) return false;
        // this._skipChangeTilingPropertiesEventOnce = true;
        const objectName = selectSelectedObjectName(getAppState());
        parsedObject = parsedObject || selectParsedObject(getAppState());
        rawObject = rawObject || selectUnitySelectedObjectInfoRaw(getAppState());
        const color = parsedObject.colorValue;
        this._addApplyTextureToHistory(objectName, mapType, 'texture');
        return {
          prevTiling,
          nextTexture,
          mapType,
          undo: async () => {
            // if (mapType !== TEXTURE_MAP.DIFFUSE) {
            //   this.unityObjectProperties.toggleCustomMap(prevTiling.tilingType, false, {
            //     skipHistory: true,
            //   });
            //   return;
            // }
            if (isMattressBuilderPage()) {
              undoRedo.pause();
              const itemsToSelect = {
                objectName: objectName,
                ObjectSelectionMode: 'Style',
                clickedObjectName: '',
              };
              window.unityContext?.mainController?.SelectObjectReceiver([itemsToSelect]);
              // await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo);
              undoRedo.resume();
            }
            await this._undoColorMaterialTexture({
              prevTiling,
              objectName,
              color,
              mapType,
              rawObject,
              parsedObject,
            });
          },
          redo: async () => {
            if (isMattressBuilderPage()) {
              undoRedo.pause();
              const itemsToSelect = {
                objectName: objectName,
                ObjectSelectionMode: 'Style',
                clickedObjectName: '',
              };
              window.unityContext?.mainController?.SelectObjectReceiver([itemsToSelect]);
              // await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo);
              undoRedo.resume();
            }
            this._addApplyTextureToHistory(objectName, mapType, 'texture');
            this._skipChangeTilingPropertiesEventOnce = true;
            await this.unityObjectProperties.applyTexture({
              mapType,
              texture: nextTexture,
              switchToProperties: true,
              skipHistory: true,
            });
          },
        };
      },
      { name: ACTION.APPLY_TEXTURE }
    );

    this.disableCustomMap = this.undoRedo.createAction(
      ({ prevValue, nextValue, tilingOptionType }) => {
        const prevTiling = selectDataByTilingType(getAppState(), tilingOptionType);
        const rawObject = selectUnitySelectedObjectInfoRaw(getAppState());
        const parsedObject = selectParsedObject(getAppState());
        const prevTextureAlpha =
          tilingOptionType === TILING_TYPE.TRANSPARENCY
            ? prevTiling?.textureAlpha
            : undefined;
        return {
          prevValue,
          nextValue,
          tilingOptionType,
          undo: async () => {
            if (prevTiling.hasMapImage && !prevTiling.materialId) {
              // previously default texture was apply reset to previous object state
              this._undoMaterial(rawObject, parsedObject);
            } else {
              // previously map was missing or different map was applied
              await this._applyTiling(prevTiling);
            }

            if (typeof prevTextureAlpha === 'boolean') {
              this.unityObjectProperties.modifyTiling(
                TILING_TYPE.TRANSPARENCY,
                'textureAlpha',
                prevTextureAlpha,
                {
                  skipHistory: true,
                }
              );
            }
          },
          redo: () => {
            this.unityObjectProperties.toggleCustomMap(tilingOptionType, nextValue, {
              skipHistory: true,
            });

            if (
              tilingOptionType === TILING_TYPE.TRANSPARENCY &&
              nextValue &&
              prevTextureAlpha
            ) {
              this.unityObjectProperties.modifyTiling(
                TILING_TYPE.TRANSPARENCY,
                'textureAlpha',
                false,
                {
                  skipHistory: true,
                }
              );
            }
          },
        };
      }
    );

    this.applyMaterial = this.undoRedo.createAction(
      ({ material }) => {
        const parsedObject = selectParsedObject(getAppState());
        const rawObject = selectUnitySelectedObjectInfoRaw(getAppState());
        const { objectName } = rawObject;
        const mapType = TEXTURE_MAP.DIFFUSE;
        this._addApplyTextureToHistory(objectName, mapType, 'material');
        const selectedObjectName = selectSelectedObjectName(getAppState());
        // when we want to undo apply material we need to apply default material
        // if previous material was default than do nothing ???
        // if previous material is not default
        // if previously material was applied -> apply previous material
        // if there was a texture applied -> check if it has material -> if it has material than apply material first and then texture
        // apply color if needed
        // apply all custom maps
        // after that we need to apply all tilings and other options (kill me)
        return {
          __ACTION__: ACTION.APPLY_MATERIAL,
          parsedObject,
          material,
          undo: async () => {
            if (isMattressBuilderPage()) {
              undoRedo.pause();
              const itemsToSelect = {
                objectName: selectedObjectName,
                ObjectSelectionMode: 'Style',
                clickedObjectName: '',
              };
              window.unityContext?.mainController?.SelectObjectReceiver([itemsToSelect]);
              // await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo);
              undoRedo.resume();
            }

            this._removeLastApplied(objectName, mapType);
            await this._undoMaterial(rawObject, parsedObject);
          },
          redo: async () => {
            if (isMattressBuilderPage()) {
              undoRedo.pause();
              const itemsToSelect = {
                objectName: selectedObjectName,
                ObjectSelectionMode: 'Style',
                clickedObjectName: '',
              };
              window.unityContext?.mainController?.SelectObjectReceiver([itemsToSelect]);
              // await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo);
              undoRedo.resume();
            }
            this._addApplyTextureToHistory(objectName, mapType, 'material');
            this.unityMaterial.applyMaterial({
              material,
              switchToProperties: true,
              skipHistory: true,
            });
          },
          cancel: () => {
            this._removeLastApplied(objectName, mapType);
          },
        };
      },
      { name: ACTION.APPLY_MATERIAL }
    );

    this.applyMaterialTextureColorInConfigurator = this.undoRedo.createAction(
      ({ material, sceneId, previousSelectedOption, currentSelectedOption }) => {
        this._addApplyTextureToHistoryInConfigurator({
          sceneId,
          labelId: currentSelectedOption?.sceneoption,
          optionId: currentSelectedOption?.id,
          type: 'material',
        });
        return {
          __ACTION__: ACTION.APPLY_MATERIAL,
          material,
          sceneId,
          previousSelectedOption,
          currentSelectedOption,
          undo: async () => {
            const isValid = validateUndoRedo({
              option: previousSelectedOption,
              labelId: previousSelectedOption?.sceneoption,
              sceneId,
            });
            if (!isValid) {
              return;
            }
            this._removeLastAppliedInConfigurator({
              sceneId,
              labelId: currentSelectedOption?.sceneoption,
              optionId: currentSelectedOption?.id,
            });
            await this._undoMaterialTextureColorInConfigurator({
              option: previousSelectedOption,
            });
          },
          redo: () => {
            const isValid = validateUndoRedo({
              option: currentSelectedOption,
              labelId: currentSelectedOption?.sceneoption,
              sceneId,
            });
            if (!isValid) {
              return;
            }
            this._addApplyTextureToHistoryInConfigurator({
              sceneId,
              labelId: currentSelectedOption?.sceneoption,
              optionId: currentSelectedOption?.id,
              type: 'material',
            });
            applyOption({
              option: currentSelectedOption,
              skipHistory: true,
            });
          },
          cancel: () => {
            const isValid = validateUndoRedo({
              option: currentSelectedOption,
              labelId: currentSelectedOption?.sceneoption,
              sceneId,
            });
            if (!isValid) {
              return;
            }
            this._removeLastAppliedInConfigurator({
              sceneId,
              labelId: currentSelectedOption?.sceneoption,
              optionId: currentSelectedOption?.id,
            });
          },
        };
      },
      { name: ACTION.APPLY_MATERIAL }
    );

    this.copyPasteMaterialFinished = this.undoRedo.createAction(() => {
      // TODO: get object which was duplicated
      const copiedMaterial = selectCopiedObjectProperties(getAppState());
      const selectedObjectList = selectSelectedObjectList(getAppState());
      const copyPasteData = { ...this.copyPasteData };
      this.resetCopyPasteData();
      const mapType = TEXTURE_MAP.DIFFUSE;
      copyPasteData.objectsBeforePaste.forEach((objectData) => {
        this._addApplyTextureToHistory(objectData.objectName, mapType, 'material');
      });
      return {
        __ACTION__: 'UNITY_OBJECT__COPY_PASTE_MATERIAL',
        copyPasteData,
        copiedMaterial,
        undo: async () => {
          this.undoRedo.pause();
          setUndoRedoLoading(true);
          const syncAsyncLoop = async (arr, callback, index = 0) => {
            if (!arr[index]) return;
            await callback(arr[index]);
            await syncAsyncLoop(arr, callback, index + 1);
          };
          await syncAsyncLoop(copyPasteData.objectsBeforePaste.reverse(), async (objectData) => {
            this._removeLastApplied(objectData.objectName, mapType);
            // undo material — select the target object first, then apply using the
            // object-receiver so only the selected object is reverted (prevents the
            // pasted material from bleeding back onto the copy source).
            const selectedObjectData = selectedObjectList.find(
              (d) => d.objectName === objectData.objectName
            );
            if (selectedObjectData) {
              this.unityContext.mainController.SelectObjectReceiver([
                mapObjectToSelect(selectedObjectData),
              ]);
            }
            await this._undoMaterial(objectData, undefined, { useObjectReceiver: true });
          });
          // select all objects
          const objectsToSelect = selectedObjectList.map(mapObjectToSelect);
          this.unityContext.mainController.SelectObjectReceiver(objectsToSelect);
          setUndoRedoLoading(false);
          this.undoRedo.resume();
        },
        redo: async () => {
          dispatcher(setCuratorLoader(false));
          await wait(10);
          copyPasteData.objectsBeforePaste.forEach((objectData) => {
            this._addApplyTextureToHistory(objectData.objectName, mapType, 'material');
          });
          this.undoRedo.pause();
          const materialConfig = copyPasteData.materialConfig;
          materialConfig['methodName'] = 'copyPasteMaterialFinished';
          const apply = async () => {
            await this.unityContext.materialModule.SetMaterialPropertiesOnObjectReceiver(
              materialConfig
            );
          };
          if (copyPasteData.objectsBeforePaste.length === 1) {
            // wait for apply to finish
            await waitForEventOnce(UnityEvent.ApplyMaterialPropertiesFinishedReceive, apply);
            // request new object info
            await waitForEventOnce(UnityEvent.ReceiveSelectedObjectInfo, () => {
              this.unityContext.materialModule.OnSelectEditMaterialReceiver();
            });
          } else {
            await apply();
          }
          // if (copyPasteData.objectsBeforePaste.length === 1) {
          //   const object = { ...copyPasteData.materialConfig, TRIGGERED_FROM_REACT: true };
          //   PubSub.publish(UnityEvent.ReceiveSelectedObjectInfo, JSON.stringify(object));
          // }
          this.undoRedo.resume();
          dispatcher(setCuratorLoader(true));
        },
      };
    });

    this.generateFromDesign = this.undoRedo.createAction(({ texture, mapType }) => {
      // this._skipChangeTilingPropertiesEventOnce = true;
      const appState = getAppState();
      const objectName = selectSelectedObjectName(appState);
      const parsedObject = selectParsedObject(appState);
      const rawObject = selectUnitySelectedObjectInfoRaw(appState);
      const color = parsedObject.colorValue;
      const tilingType = TEXTURE_MAP_TO_TILING_TYPE[mapType];
      const key = TILING_NAME_MAP[tilingType];
      const prevTiling = parsedObject[key];
      this._addApplyTextureToHistory(objectName, mapType, 'texture');
      return {
        undo: async () => {
          await this._undoColorMaterialTexture({
            prevTiling,
            objectName,
            color,
            mapType,
            rawObject,
            parsedObject,
          });
        },
        redo: async () => {
          this._addApplyTextureToHistory(objectName, mapType, 'texture');
          setGenerateFromDesignLoading(true);
          await this.unityContext.materialModule.selectLowTexture({
            texture,
            mapType,
            isGeneratedMap: true,
          });
          setGenerateFromDesignLoading(false);
        },
      };
    });

    this.disableGenerateFromDesign = this.undoRedo.createAction(
      ({ mapType }) => {
        // this._skipChangeTilingPropertiesEventOnce = true;
        // const objectName = selectSelectedObjectName(appState);
        const appState = getAppState();
        const parsedObject = selectParsedObject(appState);
        // const rawObject = selectUnitySelectedObjectInfoRaw(appState);
        // const color = parsedObject.colorValue;
        const tilingType = TEXTURE_MAP_TO_TILING_TYPE[mapType];
        const key = TILING_NAME_MAP[tilingType];
        const prevTiling = parsedObject[key];
        const textureId = prevTiling.materialId;
        // this._addApplyTextureToHistory(objectName, mapType, 'texture');
        return {
          undo: async () => {
            setGenerateFromDesignLoading(true);
            const texture = await getTexture(textureId);
            await this.unityContext.materialModule.selectLowTexture({
              texture,
              mapType,
              isGeneratedMap: true,
            });
            setGenerateFromDesignLoading(false);
          },
          redo: async () => {
            await this.unityObjectProperties.generateFromDesign(tilingType, false);
          },
        };
      },
      { pause: true }
    );

    this.breakMaterial = this.undoRedo.createAction(
      async () => {
        this.undoRedo.pause();
        try {
          const getFreshObjectState = async () => {
            await waitForEventOnce(AppEvent.ReceiveSelectedObjectInfoHandled, () => {
              this.unityContext.materialModule.OnSelectEditMaterialReceiver();
            });
            return {
              rawObject: JSON.parse(
                JSON.stringify(selectUnitySelectedObjectInfoRaw(getAppState()))
              ),
              parsedObject: JSON.parse(JSON.stringify(selectParsedObject(getAppState()))),
            };
          };

          const { rawObject: rawObjectBefore, parsedObject: parsedObjectBefore } =
            await getFreshObjectState();

          // Race success (OnReceiveBrokenMaterialName) against already-broken error
          // (OnMessageReceivedFromUnity) so the promise always resolves and paused
          // is never left permanently set to true.
          const brokenSuccessfully = await new Promise((resolve) => {
            let settled = false;
            const onSuccess = PubSub.subscribe(UnityEvent.OnReceiveBrokenMaterialName, () => {
              if (settled) return;
              settled = true;
              PubSub.unsubscribe(onSuccess);
              PubSub.unsubscribe(onError);
              resolve(true);
            });
            const onError = PubSub.subscribe(UnityEvent.OnMessageReceivedFromUnity, (_, message) => {
              if (settled || !message?.isError) return;
              settled = true;
              PubSub.unsubscribe(onSuccess);
              PubSub.unsubscribe(onError);
              resolve(false);
            });
            this.unityContext.materialModule.BreakMaterialOfSelectedObjects();
          });

          if (!brokenSuccessfully) return null;

          successToast('Material break successfully', { toastId: 'BREAK_MATERIAL_SUCCESS' });

          const { rawObject: rawObjectAfter, parsedObject: parsedObjectAfter } =
            await getFreshObjectState();

          return {
            __ACTION__: ACTION.BREAK_MATERIAL,
            undo: async () => {
              await this._undoMaterial(rawObjectBefore, parsedObjectBefore);
            },
            redo: async () => {
              await this._undoMaterial(rawObjectAfter, parsedObjectAfter);
            },
          };
        } finally {
          this.undoRedo.resume();
        }
      },
      { pause: true, name: ACTION.BREAK_MATERIAL }
    );
  };
}
